import { render, staticRenderFns } from "./GarmentDevDashboard.vue?vue&type=template&id=2d879576&"
import script from "./GarmentDevDashboard.vue?vue&type=script&lang=js&"
export * from "./GarmentDevDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports